<div class="example-header">
  <mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Ingrese el texto a filtrar en la lista de notas">
  </mat-form-field>
</div>

<div class="example-container mat-elevation-z8">

  <mat-table [dataSource]="dataSource" matSort>

    <!-- ID Column -->
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.id}} </mat-cell>
    </ng-container>

    <!-- nombre Column -->
    <ng-container matColumnDef="nombre">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.nombre}}% </mat-cell>
    </ng-container>

    <!-- estado Column -->
    <ng-container matColumnDef="estado">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Estado </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.estado}} </mat-cell>
    </ng-container>

    <!-- prioridad Column -->
    <ng-container matColumnDef="prioridad">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Prioridad </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.prioridad}} </mat-cell>
    </ng-container>

    <!-- tipo Column -->
    <ng-container matColumnDef="tipo">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.tipo}} </mat-cell>
    </ng-container>

    <!-- usuario Column -->
    <ng-container matColumnDef="usuario">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Usuario </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.usuario}} </mat-cell>
    </ng-container>

    <!-- archivo Column -->
    <!--
    <ng-container matColumnDef="archivo">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Archivo </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.archivo}} </mat-cell>
    </ng-container>
-->
    <!-- comentario Column -->
    <!--
    <ng-container matColumnDef="comentario">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Cometario </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.comentario}} </mat-cell>
    </ng-container>
-->
    <!-- fecha_de_creacion Column -->
    <ng-container matColumnDef="fecha_de_creacion">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Fecha de Creacion </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.fecha_de_creacion}} </mat-cell>
    </ng-container>

    <!-- latitud Column -->
    <ng-container matColumnDef="latitud">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Latitud </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.latitud}} </mat-cell>
    </ng-container>

    <!-- longitud Column -->
    <ng-container matColumnDef="longitud">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Longitud </mat-header-cell>
      <mat-cell *matCellDef="let row"> {{row.longitud}} </mat-cell>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="accion">
      <th mat-header-cell *matHeaderCellDef> Acciones </th>
      <td mat-cell *matCellDef="let element" class="action-link">
      <button mat-icon-button color="primary" (click)="redirectToDetails(element)" routerLink="/list" [queryParams]="{id: element.id ,accion: 'ver', dialog: 'true'}">
        <mat-icon class="mat-18">note</mat-icon>
    </button>
    <button mat-icon-button color="primary" (click)="redirectToUpdate(element)"  routerLink="/list" [queryParams]="{id: element.id ,accion: 'edicion', dialog: 'true'}">
      <mat-icon class="mat-18">edit</mat-icon>
  </button>
  <button mat-icon-button color="warn" (click)="redirectToDelete(element)">
    <mat-icon class="mat-18">delete</mat-icon>
    </button>
  <!--
        <a (click)="openDialog('Show',element)"><mat-icon matSuffix>note</mat-icon></a>
        <a (click)="openDialog('Update',element)"><mat-icon matSuffix>edit</mat-icon></a>
        <a (click)="openDialog('Delete',element)"><mat-icon matSuffix>delete</mat-icon></a>
        -->
      </td>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;">
    </mat-row>
  </mat-table>

  <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
</div>


<!-- Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
